import React from 'react';
import {PropTypes} from 'prop-types';
import HrbTranslate from '../language/HrbTranslate';
import './Button.scss';


const Button = (props) => {
  var buttonClass = props.isAlt ? "hrb-alt-button btn" : "hrb-button btn"
  return (
    <button className={buttonClass} onClick={props.onClick} disabled={props.isDisabled}>
      <HrbTranslate text={props.text} params={props.params} />
      {props.children}
    </button>
  );
}

Button.propTypes = {
  //TODO: make this required once the landing page onClick functions are fixed
  onClick: PropTypes.func,
  text: PropTypes.string.isRequired,
  isDisabled: PropTypes.bool,
  params: PropTypes.object,
  isAlt: PropTypes.bool
};

export default Button;
